
import { Component, Vue } from 'vue-property-decorator';
import { api } from '@/api';
import store from '@/store';
import { readInactivityLocked, readUserProfile } from '@/store/main/getters';
import { commitSetInactivityLocked } from '@/store/main/mutations';
import { saveLocalToken, saveLocalRefreshToken, saveLastActivity } from '@/utils';

@Component
export default class InactivityLockDialog extends Vue {
  public password = '';
  public otp: string | null = null;
  public loading = false;
  public error: string | null = null;

  get isLocked() {
    return readInactivityLocked(store);
  }

  get userEmail() {
    return readUserProfile(store)?.email ?? '';
  }

  get mfaEnabled() {
    return readUserProfile(store)?.mfa_enabled ?? false;
  }

  public async submit() {
    if (this.loading || !this.userEmail) return;
    this.loading = true;
    this.error = null;
    try {
      const response = await api.logInGetToken(this.userEmail, this.password, this.mfaEnabled ? this.otp : null);
      const accessToken = response.data.access_token;
      if (accessToken) {
        saveLocalToken(accessToken, this.userEmail);
        if (response.data.refresh_token) {
          saveLocalRefreshToken(response.data.refresh_token, this.userEmail);
        }
        saveLastActivity(this.userEmail);
        this.password = '';
        this.otp = null;
        commitSetInactivityLocked(store, false);
      }
    } catch (err: any) {
      if (err?.response?.status === 423) {
        this.error = this.$t('login.accountLocked') as string;
      } else {
        this.error = this.mfaEnabled
          ? this.$t('login.invalidCredentialsOtp') as string
          : this.$t('login.invalidCredentials') as string;
      }
    } finally {
      this.loading = false;
    }
  }
}
